import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { DoctorInfoResponse } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';

interface DoctorsRequest {
  practiceId: string;
  enabled?: boolean;
}

const useDoctors = ({ practiceId, enabled }: DoctorsRequest) => {
  const url = useApiUrl(
    OBRoutes.DoctorInfo,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBQuery<DoctorInfoResponse>(url, {
    enabled: !!url && enabled,
    staleTime: 600000,
  });
};

export default useDoctors;
